/**
 * AlmadarPostLearningFromInterruptionsARPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostLearningFromInterruptionsARPostPage
 */

import { useAlmadarPostLearningFromInterruptionsARPostPageLogic } from '@/hooks/traits/useAlmadarPostLearningFromInterruptionsARPostPageLogic';
import type { AlmadarPostLearningFromInterruptionsARPostPageConfig } from '@/hooks/traits/useAlmadarPostLearningFromInterruptionsARPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostLearningFromInterruptionsARPostView as AlmadarPostLearningFromInterruptionsARPostViewEntity } from '@app/shared';
import { AlmadarPostLearningFromInterruptionsARPostHeaderView } from '@/components/traits/AlmadarPostLearningFromInterruptionsARPostHeaderView';
import { Stack } from '@almadar/ui/components';
import { Container } from '@almadar/ui/components';
import { Box } from '@almadar/ui/components';
import { AlmadarPostLearningFromInterruptionsARPostView } from '@/components/traits/AlmadarPostLearningFromInterruptionsARPostView';
import { AlmadarPostLearningFromInterruptionsARPostFooterView } from '@/components/traits/AlmadarPostLearningFromInterruptionsARPostFooterView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostLearningFromInterruptionsARPostPageViewProps {
  config?: Partial<AlmadarPostLearningFromInterruptionsARPostPageConfig>;
}

export function AlmadarPostLearningFromInterruptionsARPostPageView({ config: propsConfig }: AlmadarPostLearningFromInterruptionsARPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostLearningFromInterruptionsARPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostLearningFromInterruptionsARPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostLearningFromInterruptionsAR" trait="AlmadarPostLearningFromInterruptionsARPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="AlmadarPostLearningFromInterruptionsARPostPage">{slotWriter['main'] === 'INIT' ? (<Stack gap="none" direction="vertical"><AlmadarPostLearningFromInterruptionsARPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box bg="transparent" paddingY="xl" fullWidth={true}><Container size="xl" maxWidth="xl" padding="lg"><AlmadarPostLearningFromInterruptionsARPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><AlmadarPostLearningFromInterruptionsARPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostLearningFromInterruptionsARPostPageView;
